import type { ReactElement, ReactNode } from "react";

import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IProps {
    text: string;
    children: ReactNode | ReactNode[];
}

export const FormFieldLabel = ({ text, children }: IProps): ReactElement => {
    return (
        <Flex
            flexDirection="column"
            gap="8px"
            data-automation="form-field-label-container"
        >
            <Text
                fontVariant="sectionTitle"
                data-automation="form-field-label"
            >
                {text}
            </Text>
            {children}
        </Flex>
    );
};
